import { getApiClient } from '../client'
import { handleApiError } from '../utils/handleApiError'
import type { RunStartRequest, RunStartResponse, RunStatusResponse } from '@dopomogai/types'

type SR<T> = Promise<T | import('@dopomogai/types').ApiErrorResponse>

const startRun = (payload: RunStartRequest): SR<RunStartResponse> =>
  getApiClient().post('/automations/content/run', payload)
    .then(res => res.data)
    .catch(err => handleApiError(err, 'starting content run'))

const getRun = (runId: string): SR<RunStatusResponse> =>
  getApiClient().get(`/automations/content/${encodeURIComponent(runId)}`)
    .then(res => res.data)
    .catch(err => handleApiError(err, `getting run ${runId}`))

// Note: we’ll stream logs via fetch in hooks (so we can set auth headers).
export const automationsContentService = { startRun, getRun }